import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Services from "@/components/Services";
import Gallery from "@/components/Gallery";
import WhyChoose from "@/components/WhyChoose";
import Testimonials from "@/components/Testimonials";
import ContactForm from "@/components/ContactForm";
import Footer from "@/components/Footer";

export default function Home() {
  return (
    <div className="min-h-screen bg-[color:var(--vs-bg)] text-white">
      <Header />
      <main>
        <Hero />
        <Services />
        <Gallery />
        <WhyChoose />
        <Testimonials />
        <ContactForm />
      </main>
      <Footer />
    </div>
  );
}
